export default class Contact {

	constructor () {
		const xhr  = new XMLHttpRequest();
		xhr.onload = function () {
			const d     = document.createElement('div');
			d.innerHTML = this.responseText;

			const forms = document.querySelectorAll('form');
			for (let i = 0, l = forms.length; i < l; i++)
				forms[i].appendChild(d.firstElementChild);
		};
		xhr.open('GET', '/actions/blitz/csrf/input');
		xhr.send();
	}

}